<template>
  <div class="page-template add-page order-add-page">
    <div class="page-title">{{ title }}
    </div>
    <div class="btn-box">
      <el-button type="primary" plain @click="beBack">返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <div></div>
    <list-operation-form v-show="complexShow" ref="listOperationForm" :formOptions="listFormOptions"
                         @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good"
      >选择商品
      </el-button
      >
      <el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>
      <el-button @click="importData" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800" v-if="componentsFlag"
               :close-on-click-modal="true">
      <good-list
        v-if="listShow"
        ref="goodsListOperation"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :otherParam="otherParam"
        :tableOptions="tableOptions"
        @selectSubmit="rowsSelectSubmit"
        :listTableData="listTableData"
        :selectUrl="selectUrl"></good-list>
    </el-dialog>
    <div
      v-loading.fullscreen.lock="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(225, 225, 225, 0.9)"
    >
    </div>
  </div>
</template>
<script>
  //商品列表组件
  import goodList from '@/components/business/goodList';
  //添加要货单组件
  import listOperationNew from "@/components/template/listOperationNew";
  //要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';

  export default {
    components: {
      listOperationNew,
      goodList,
      listOperationForm
    },
    data() {
      return {
        isCheck: false,
        complexShow: true,
        goodsTxt: "",
        listTableData: [],
        blitemGoodsMapOrderNo: '',
        goodListSelect: false,
        isSelectWarehouse: true,
        isSelectBatch: true,
        warehouseId: {},
        defaultParams: {},
        loading: false,
        componentsFlag: true,
        title: '',
        listShow: false,
        goodList: [],
        formModel: {},
        dialogShow: false,
        otherParam: {statusList: [10, 20, 30]},
        selectUrl: {url: api.warehouse.warehouseGoods},
        isUpdate: true,
        // 添加头部字段
        //条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            }
          },
          labelWidth: '130px',
          columns:
            [
              {
                label: "盘点来源",
                type: "select",
                prop: "relateType",
                data: this.$utils.getCacheStatus('weBlitemOrder.relateType'),
                defaultValue: this.$utils.getSysUser().storeId ? 20 : 10,
                hidden: true
              },
              {
                label: "仓库",
                type: "warehouseInputDialog",
                prop: "warehouseId",
                // url: api.warehouse.warehouse,
                // change: this.getBatchOrder,
                // param: {relateType: this.$utils.getSysUser().storeId ? 20 : 10},
                // data: [],
                span: 12,
                // disabled: false,
              },
              {
                label: '盘点单批号',
                type: 'inventoryOrderInputDialog',
                prop: 'batchOrderNo',
                data: [],
                labelKey: 'orderNo',
                uniqueKey: 'orderNo',
                // change: this.orderNoChange,
                span: 12,
                disabled: false,
                url: api.warehouse.batch + '/batch/number/page',
                columns: [
                  {label: "单号", prop: "orderNo", align: "center"},
                  {
                    label: "盘点范围",
                    prop: "type",
                    enumData: this.$utils.getCacheStatus('weBatchNumberOrder.type'),
                    align: "center"
                  }
                ]
              },
              {
                label: '主键id',
                type: 'input',
                prop: 'id',
                hidden: true
              },
              {
                label: '盘点单号',
                type: 'input',
                prop: 'orderNo',
                hidden: true
              },
              {
                label: '盘点单批号ID',
                type: 'input',
                prop: 'batchId',
                hidden: true
              },
              {
                label: '盘点范围',
                type: 'select',
                prop: 'type',
                disabled: true,
                span: 12,
                data: this.$utils.getCacheStatus('weBatchNumberOrder.type')
              },
              {
                label: '盘点范围',
                type: 'input',
                prop: 'type',
                hidden: true,
              },
              {
                label: '备注',
                type: 'input',
                prop: 'remarks',
                span: 12,
              },
              {
                label: '盘点信息',
                type: 'input',
                prop: 'retaleInfo',
                span: 12,
                disabled: true,
              }]
        },
        // 添加表格字段
        listColumns: {
          disabled: false,
          indexShow: true,//是否显示索引
          summaryColumns: ['blitemNum', 'amountInventory'],
          columns: [
            {label: '操作', type: 'operation', width: 50, prop: 'operation'},
            {label: '序号', type: 'index', width: 50, prop: 'idx'},
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '100'
            },
            {
              label: '成本价',
              prop: 'purchasePrice',
              width: '100'
            },
            {
              label: '数量',
              width: '100',
              prop: 'blitemNum',
              type: 'inputNumber',
              change: this.numChange,
              precision: 2
            },
            {
              label: '成本金额',
              prop: 'amountInventory',
              width: '100'
            },
            {
              label: '类别',
              prop: 'goodsCategoryName',
              width: '100'
            },
            {
              label: '品牌',
              prop: 'goodsBrandName',
              width: '100'
            },
            // {
            //   label: '备注',
            //   prop: 'remarks',
            //   type: 'input',
            //   maxLength: 16,
            //   width: '90',
            // },

          ],
          param: {orderNo: null},
          url: api.warehouse.weBlitemGoodsMap + '/map',

        },
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '200',
              align: 'center'
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "100",
              align: "center"
            },
            {
              label: "规格",
              prop: "specs",
              width: "100",
              align: "center"
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '200',
              align: 'center'
            },
            {
              label: '成本价',
              prop: 'purchasePrice',
              width: '100'
            },
          ],
          param: this.defaultParams,
        },
        checkIndex: ''
      }
    },
    created() {
      this.title = document.title + (this.$route.query.id ? '编辑' : '新增');
      if (this.$route.query.id) {
        this.getDetail();
      } else {
        this.$nextTick(() => {
          let warehouseId = this.$utils.getSysUser().warehouseId;
          this.$refs.listOperationForm.formModel.warehouseId = warehouseId;
          this.otherParam.warehouseId = warehouseId;
          this.isSelectWarehouse = false;
          this.listFormOptions.columns.filter(
            item => item.prop === "batchOrderNo"
          )[0].params = {warehouseId: warehouseId};
        })
      }
    },
    mounted() {
      this.$refs["listOperation"].tableRow.blitemNum = 0.00
    },
    methods: {
      //点击 高级搜索显示
      complexFunc() {
        if (!this.isCheck) {
          this.complexShow = !this.complexShow;
        }
      },
      listFormValueChange(value, column) {
        if (column.prop == "warehouseId") {
          this.otherParam.warehouseId = value;
          this.isSelectWarehouse = false;
          this.listFormOptions.columns.filter(
            item => item.prop === "batchOrderNo"
          )[0].params = {warehouseId: value};
        }
        if (column.prop == "batchOrderNo") {
          this.orderNoChange(value);
        }
      },
      search() {
        if (this.goodsTxt === '' || this.goodsTxt === null) return;
        this.otherParam.otherName = this.goodsTxt;
        if (this.isSelectWarehouse) {
          this.goodsTxt = '';
          this.$confirm("请选择仓库！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else if (this.isSelectBatch) {
          this.goodsTxt = '';
          this.$confirm("请选择盘点批号", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          this.isCheck = true;
          this.$axios
            .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
            .then(res => {
              if (res.code === 200) {
                if (res.data.length > 0) {
                  let tableData = res.data;
                  if (tableData.length === 1) {
                    let row = tableData[0];
                    let tableList = this.$refs["listOperation"].getTabelData();
                    let flag = true;
                    if (tableList.length > 0) {
                      tableList.forEach(item => {
                        if (flag) {
                          if (item.barCode === row.barCode) flag = false;
                        }
                      });
                    }
                    if (!flag) {
                      this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                      return;
                    }
                    this.$refs["listOperation"].setColumnData(row, tableList.length);
                    this.currentTableList = this.$refs["listOperation"].getTabelData();
                    this.$message.success("商品添加成功");
                  } else {
                    this.checkGoods();
                  }
                } else {
                  this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
                }
              } else {
                this.$message({type: "error", message: res.msg});
              }
            })
            .catch(err => {
            }).finally(() => {
            this.clearQueryParam();
            this.isCheck = false;
          });

        }
      },
      clearQueryParam() {
        this.goodsTxt = '';
        this.otherParam.otherName = '';
      },
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.warehouse.blitem + '/id?id=' + this.$route.query.id, {})
          .then(data => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              this.blitemGoodsMapOrderNo = data.data['orderNo'];
              this.formModel = data.data;
              if (this.formModel.reviewerStatus == 10) {
                this.listFormOptions.disabled = true;
                this.listColumns.disabled = true;
              }
              this.$nextTick(() => {
                //为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                this.otherParam.warehouseId = data.data.warehouseId;
                if (data.data.type === 30) {
                  this.otherParam.goodsCategoryIds = data.data.retaleIds.split(",");
                }
                if (data.data.type === 40) {
                  this.otherParam.goodsBrandIds = data.data.retaleIds.split(",");
                }
                // this.$refs['listOperation'].addMoreRow(data.data.weBlitemGoodsMapMVOList, 0);
                // 已经选择的仓库和单号不允许修改 此处数组顺序指的是属性在表单的顺序
                this.$refs.listOperationForm.formOptions.columns[1].disabled = true;
                this.$refs.listOperationForm.formOptions.columns[2].disabled = true;
                this.isSelectWarehouse = false;
                this.isSelectBatch = false;
                this.isUpdate = false;
                this.listColumns.param.id = this.$route.query.id;
                //为表格赋值
                this.$refs['listOperation'].addMoreRow(data.data.weBlitemGoodsMapMVOList, 0);
                // this.listTableData = this.$refs["listOperation"].getTabelData();
                // this.$refs['listOperation'].getTabelData();
              });
            } else if (data.code == 200 && !data.data) {
              this.$message({message: '获取数据出错！', type: 'error'});
              this.$router.push({path: '/warehouse/inventory/goods'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },
      checkGoods() {
        if (this.isSelectWarehouse) {
          this.$confirm("请选择仓库", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else if (this.isSelectBatch) {
          this.$confirm("请选择盘点批号", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          this.listShow = true;
          this.goodListSelect = true;
          this.listTableData = this.$refs["listOperation"].getTabelData();//table数据
          // this.$nextTick(() => {
          //   this.$refs['goodsListOperation'].getTableData(this.otherParam);
          // });
        }
      },
      // 多选 确认
      rowsSelectSubmit(rows) {
        if (rows.length > 0) {
          rows.map(item => {
            item.blitemNum = 0.00.toFixed(2);
            item.amountInventory = 0.00.toFixed(2);
          });
          let param = {
            orderNo: this.blitemGoodsMapOrderNo,
            goodsMapList: rows
          };
          this.loading = true;
          this.$axios.fetchPost(api.warehouse.weBlitemGoodsMap + '/batch/insert', param).then(data => {
            if (data.code === 200) {
              if (data.data.length > 0) {
                //给参数赋值，方便后面页面调整
                this.listColumns.param.orderNo = data.data[0].orderNo;
                this.listColumns.param.id = null;
                for (let i = 0; i < rows.length; i++) {
                  for (let j = 0; j < data.data.length; j++) {
                    if (rows[i]['goodsId'] === data.data[i]['goodsId']) {
                      rows[i]['weBlitemGoodsMapId'] = data.data[i]['weBlitemGoodsMapId'];
                      break
                    }
                  }
                }
                let tableList = this.$refs['listOperation'].getTabelData();
                this.$refs['listOperation'].addMoreRow(rows, tableList.length);
                this.listTableData = this.$refs["listOperation"].getTabelData();
                this.componentsFlag = false;
                this.$nextTick(() => {
                  this.componentsFlag = true
                })
              }
            }
          }).finally(() => {
            this.loading = false;
            this.listShow = false;
          });
          this.$message.success("商品添加成功");
        }
      },
      numChange(row, index) {
        if (row.blitemNum > 9999.999) {
          row.blitemNum = 9999.999;
        }
        if (row.purchasePrice && row.blitemNum) {
          row.amountInventory = parseFloat(row.purchasePrice * row.blitemNum).toFixed(2);
          // 修改盘点商品
          // let param = {
          //   id: row.weBlitemGoodsMapId,
          //   blitemNum: row.blitemNum,
          //   amountInventory: row.amountInventory
          // };
          // this.loading = true;
          // this.$axios.fetchPut(api.warehouse.weBlitemGoodsMap, param).then(data => {
          //   if (data.code === 200) {
          //     this.$refs['listOperation'].setCountData(row, index);
          //     this.loading = false;
          //   }
          // }).catch((err) => {
          //   this.loading = false;
          // });
        } else {
          row.blitemNum = '0.00'
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      //选择某行数据
      rowCheck(row) {
        row.amountInventory = 0.00.toFixed(2);
        row.blitemNum = 0.00.toFixed(2);
        //单行商品选择的时候，给商品关联表插入数据
        row.orderNo = this.blitemGoodsMapOrderNo;
        this.$axios.fetchPost(api.warehouse.weBlitemGoodsMap, row).then(data => {
          if (data.code === 200) {
            row.weBlitemGoodsMapId = data.data.id;
            this.listColumns.param.orderNo = data.data.orderNo;
            this.listColumns.param.id = null;
            this.listShow = false;
            this.$refs['listOperation'].setColumnData(row, this.checkIndex);
            this.listTableData = this.$refs["listOperation"].getTabelData();
          } else {
            this.$message({message: '请求失败！', type: 'error'});
          }
        });
      },
      //提交数据
      submitAuth() {
        if (!this.isCheck) {
          let tableList = this.$refs['listOperation'].getTabelData();
          let orderNumber = 1;
          tableList.map(item => {
            item.orderNumber = orderNumber++;
            if (item.goodsId == null) {
              item.goodsId = item.id;
            }
          });
          let totalParam = this.$refs['listOperation'].getSumData();
          let headParam = this.$refs.listOperationForm.getFormModel()
          let searchParam = {
            ...{weBlitemGoodsMapMVOList: tableList}, ...totalParam, ...headParam
          };
          if (!searchParam.warehouseId) {
            this.$confirm("请选择仓库！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            });
          } else if (!searchParam.batchOrderNo) {
            this.$confirm("请选择盘点单批号！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            });
          } else if (searchParam.weBlitemGoodsMapMVOList.length === 0) {
            this.$message({message: '商品信息无效', type: 'warning'});
          } else {
            let testSave = false
            testSave = searchParam.weBlitemGoodsMapMVOList.every(v => {
              if (v.goodsName) {
                return true
              } else {
                return false
              }
            })
            if (testSave) {
              this.save(searchParam)
            }
          }
        }
      },
      save(searchParam) {
        if (this.blitemGoodsMapOrderNo) {
          this.$loading({text: '提交中，请稍后。。。'});
          Object.assign(searchParam, {orderNo: this.blitemGoodsMapOrderNo});
          this.$axios
            .fetchPost(api.warehouse.blitem, searchParam)
            .then(data => {
              this.loading = false;
              if (data.code == 200) {
                this.$notify({
                  type: "success",
                  title: '提交操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '存货盘点单操作成功', type: 'success'});
                // this.$refs.listOperationForm.formModel = data.data;
                // this.$set(this.$refs.listOperationForm.formModel, 'reviewerStatus', 20);
                // 已经选择的仓库和单号不允许修改 此处数组顺序指的是属性在表单的顺序
                // this.$refs.listOperationForm.formOptions.columns[1].disabled = true;
                // this.$refs.listOperationForm.formOptions.columns[2].disabled = true;
                this.beBack();
                // if(data.data){
                //   setTimeout(()=>{
                //     this.getDetail(data.data.id)
                //   },1000)
                // }
              } else {
                this.$message({message: data.msg, type: 'error'});
              }
            }).catch(err => {
            this.$notify({
              type: "error",
              title: '提交操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          }).finally(() => {
            this.$loading({}).close()
          });
        } else {
          this.$message({message: '存货盘点单号不存在,无法进行保存', type: 'warning'});
        }
      },
      addRequisition() {
        this.dialogShow = true;
      },
      orderNoChange(data) {
        this.$refs['listOperation'].clearTableData();
        this.isSelectBatch = false;
        this.otherParam.warehouseId = this.$refs.listOperationForm.formModel.warehouseId;
        this.$refs.listOperationForm.formModel.type = data.type;
        this.$refs.listOperationForm.formModel.batchOrderNo = data.orderNo;
        this.$refs.listOperationForm.formModel.retaleInfo = data.retaleInfo;
        this.$refs.listOperationForm.formModel.batchId = data.id;
        if (data.type === 30) {
          this.otherParam.goodsCategoryIds = data.retaleIds.split(",");
        }
        if (data.type === 40) {
          this.otherParam.goodsBrandIds = data.retaleIds.split(",");
        }
        this.$axios.fetchPost(api.warehouse.blitem + '/create/order', {}).then(data => {
          if (data.code === 200) {
            this.blitemGoodsMapOrderNo = data.data;
          }
        }).catch((err) => {
          this.listFormOptions.columns['batchOrderNo'] = '';
        });
      },
      //返回按钮事件
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },
      refresh() {
        if (!this.isCheck) {
          this.$router.go(0);
        }
      },
      valueChange() {
        console.log(1251);
      },
      getBatchOrder(params) {
        // 选择商品前选中仓库
        this.isSelectWarehouse = false;
        // 选中商品组件查询条件
        this.otherParam.warehouseId = params.warehouseId;
        // 根据仓库获取盘点批号
        this.$axios.fetchPost(api.warehouse.batch + '/batch/number/list', {
          reviewerStatus: 20,
          relateType: this.$utils.getSysUser().storeId ? 20 : 10,
          warehouseId: params.warehouseId
        }).then(data => {
          if (data.code === 200) {
            this.clearData();
            this.listFormOptions.columns.filter(item => item.prop === 'batchOrderNo')[0].data = data.data;
          }
        })
      },
      clearData() {
        if (this.isUpdate) {
          this.$refs.listOperationForm.formModel.batchOrderNo = "";
          this.$refs.listOperationForm.formModel.type = "";
          this.$refs.listOperationForm.formModel.retaleInfo = "";
          this.$refs['listOperation'].clearTableData();
          this.isUpdate = true;
        }
      },
      downloadTemplate() {
        if (!this.isCheck) {
          this.$axios.fetchPost(api.warehouse.downloadTemplate).then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      },
      importData() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.warehouseId) {
            console.log(tableData);
            this.$utils.uploadFile((file) => {
              this.loading = true;
              let formData = new FormData();
              formData.append('multipartFile', file);
              formData.append('warehouseId', tableData.warehouseId);
              formData.append('orderNo', this.blitemGoodsMapOrderNo);
              formData.append('batchId', tableData.batchId);
              formData.append('relateType', tableData.relateType);
              formData.append('type', tableData.type);
              formData.append('batchOrderNo', tableData.batchOrderNo);
              this.$axios
                .fetchPostGoodsExport(api.warehouse.blitemGoodsImport, formData)
                .then(data => {
                  if (data.code === 200) {
                    this.$message({message: "数据开始导入，大约十分钟后进行查看。", type: "success"});
                    this.$router.push({path: '/warehouse/inventory/goods'});
                  } else {
                    if (data.errorMsg) {
                      this.$message({message: data.errorMsg, type: "error"});
                    } else {
                      this.$notify({
                        type: "error",
                        title: '导入操作',
                        message: '失败',
                        showClose: false,
                      });
                      // this.$message({message: "导入异常", type: "error"});
                    }
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  console.log(err);
                });
            });
          } else {
            this.$message({message: '请选择仓库！', type: 'warning'});
          }
        }
      },
      exportErrorData(data) {
        const elink = document.createElement('a');
        elink.href = data;
        elink.click();
        this.loadingExt = false;
        this.$notify({
          type: "success",
          title: '错误商品导出操作',
          message: '成功',
          showClose: false,
        });

        // this.$message({message: '错误商品导出成功', type: 'success'});
      },
    }

  }
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/page/warehouse/inventory/GoodsAdd.vue